import { useTheme } from '@mui/material';
import { usePermify } from 'modules/auth/context';
import { EPermission } from 'modules/auth/context/permify/permify.interfaces';
import { useEffect, useState, useCallback } from 'react';
import { BoxSection, ButtonPrimary, TextM } from 'app/components';
import { CopyIcon, HandCoinIcon, HyperlinkIcon } from 'app/components/Icons';
import { TProducts } from '../../../../context';
import { ApplicationContent } from '../ApplicationContent';
import { ProductDetailsContentHeaderButtons, StyledTitle } from './styles';
import { routingPath } from 'app/routes';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSnackbar } from 'app/hooks/useSnackbar';
import { CustomTabs } from 'app/components/CustomTabs';
import PanelTitle from 'app/components/typography/heading/PanelTitle/PanelTitle';
import { TabsArea } from 'app/components/Tabs/styles';

interface IProductsDetailsContent {
  productData: TProducts | null;
}

const productTabsValueContent = (
  productData: TProducts | null,
  tabName: string,
) => {
  if (productData?.borrower_type === 'PERSON') {
    const tabItems: { [key: string]: JSX.Element } = {
      ['applications']: <ApplicationContent />,
    };

    return tabItems[tabName];
  }
  if (productData?.borrower_type === 'BUSINESS') {
    const tabItems: { [key: string]: JSX.Element } = {
      ['applications']: <ApplicationContent />,
    };

    return tabItems[tabName];
  }

  return null;
};

const ProductsDetailsContent = ({ productData }: IProductsDetailsContent) => {
  const [currentTabValue, setCurrentTabValue] = useState(0);
  const { showSnackbarCopyLink, showSnackbarCopy } = useSnackbar();
  const { isAuthorized } = usePermify();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const theme = useTheme();

  const tabItems = [
    {
      title: 'Solicitações',
      route: '/applications',
      isEnabled: true,
      icon: <HandCoinIcon color={theme.palette.brand.primary.base as string} />,
      permission: EPermission.PRODUCTS_APPLICATIONS,
    },
  ];

  const handleCopyId = useCallback(() => {
    navigator.clipboard.writeText(productData?.id as string);
    showSnackbarCopy();
  }, [productData]);

  const handleCopyLink = useCallback(() => {
    navigator.clipboard.writeText(window.location.href);
    showSnackbarCopyLink();
  }, [productData, location]);

  useEffect(() => {
    if (!params.tabRoute) {
      navigate(`${location.pathname}/applications?page=0`);
    }
  }, []);

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <StyledTitle>
          <PanelTitle>{productData?.name}</PanelTitle>
          <span>{productData?.description}</span>
        </StyledTitle>
        <ProductDetailsContentHeaderButtons>
          <ButtonPrimary
            style={{ backgroundColor: 'transparent' }}
            typeVariant="outline"
            btnIcon={
              <CopyIcon color={theme.palette.brand.primary.base as string} />
            }
            iconPosition="left"
            onClick={handleCopyId}
          >
            <TextM
              weight="Semibold"
              style={{
                marginLeft: '11px',
                color: theme.palette.brand.primary.base,
              }}
            >
              Copiar ID
            </TextM>
          </ButtonPrimary>
          <ButtonPrimary
            style={{ backgroundColor: 'transparent' }}
            typeVariant="outline"
            btnIcon={
              <HyperlinkIcon
                color={theme.palette.brand.primary.base as string}
              />
            }
            iconPosition="left"
            onClick={handleCopyLink}
          >
            <TextM
              weight="Semibold"
              style={{
                marginLeft: '11px',
                color: theme.palette.brand.primary.base,
              }}
            >
              Copiar Link
            </TextM>
          </ButtonPrimary>
        </ProductDetailsContentHeaderButtons>
      </div>
      <TabsArea>
        <CustomTabs
          value={currentTabValue}
          route={routingPath.products.detail}
          variant="scrollable"
          items={tabItems
            .filter((tab) => isAuthorized(tab.permission) && tab.isEnabled)
            .map((tab) => ({
              title: tab.title,
              icon: tab.icon,
              route: tab.route,
            }))}
          handleChange={(value) => setCurrentTabValue(value)}
          showBorder={false}
        />
      </TabsArea>
      <BoxSection level="wrapper">
        {productTabsValueContent(
          productData,
          params.tabRoute || 'applications',
        )}
      </BoxSection>
    </>
  );
};

export default ProductsDetailsContent;
